var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('BButton',{attrs:{"variant":"primary"},on:{"click":_vm.onGenerate}},[_vm._v(" Generate password ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }